import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'appStatusLabel' })
export class StatusLabelPipe implements PipeTransform {
    transform(status: string): string {
        if (status.match(/^Available.*/i)) {
            return 'label-success';
        }
        switch (status.toLowerCase()) {
            case 'in progress':
                return 'label-info';
            case 'purged':
                return 'label-success';
            case 'abandoned':
            case 'unavailable':
            case 'error':
                return 'label-danger';
            case 'rejected':
            default:
                return 'label-warning';
        }
    }
}
